import { polyfillResolve } from './manifest.utils.js';

const polyfillConfigs = [
    {
        loadCondition: ()=>typeof window !== 'undefined' && typeof window.HTMLDialogElement === 'undefined',
        scriptFileName: 'modal-dialog.js'
    }
];
function getSwanScriptPolyfillUrl(name, base) {
    return polyfillResolve(name, base);
}
function generatePolyfillElements(swanBaseUrl) {
    const scriptFragment = document.createDocumentFragment();
    polyfillConfigs.forEach((polyfill)=>{
        const { loadCondition , scriptFileName  } = polyfill;
        if (!loadCondition()) {
            return;
        }
        if (scriptFileName) {
            const url = getSwanScriptPolyfillUrl(scriptFileName, swanBaseUrl);
            const script = document.createElement('script');
            script.src = url;
            script.type = 'text/javascript';
            script.defer = true;
            scriptFragment.appendChild(script);
        }
    });
    return {
        scriptFragment
    };
}
const loadSwanPolyfill = (swanBaseUrl)=>{
    const { scriptFragment  } = generatePolyfillElements(swanBaseUrl);
    document.head.appendChild(scriptFragment);
};

export { getSwanScriptPolyfillUrl, loadSwanPolyfill };
